import * as tf from '@tensorflow/tfjs-core';
export function normalize(x) {
    return tf.tidy(function () { return tf.mul(tf.sub(x, tf.scalar(127.5)), tf.scalar(0.0078125)); });
}
//# sourceMappingURL=normalize.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/mtcnn/normalize.js
// module id = 1599
// module chunks = 0